// IATA airport code -> city + IANA time zone, for the airports we're most likely to see.
// Not exhaustive: an unknown code is a validation *warning*, not an error, and the AI
// extraction can supply the zone itself. Extend freely.

export interface AirportInfo {
  city: string;
  timeZone: string;
}

export const AIRPORTS: Record<string, AirportInfo> = {
  // United States: Northeast
  JFK: { city: 'New York', timeZone: 'America/New_York' },
  LGA: { city: 'New York', timeZone: 'America/New_York' },
  EWR: { city: 'Newark', timeZone: 'America/New_York' },
  BOS: { city: 'Boston', timeZone: 'America/New_York' },
  PHL: { city: 'Philadelphia', timeZone: 'America/New_York' },
  DCA: { city: 'Washington', timeZone: 'America/New_York' },
  IAD: { city: 'Washington', timeZone: 'America/New_York' },
  BWI: { city: 'Baltimore', timeZone: 'America/New_York' },
  PIT: { city: 'Pittsburgh', timeZone: 'America/New_York' },
  BDL: { city: 'Hartford', timeZone: 'America/New_York' },
  PVD: { city: 'Providence', timeZone: 'America/New_York' },
  ALB: { city: 'Albany', timeZone: 'America/New_York' },
  BUF: { city: 'Buffalo', timeZone: 'America/New_York' },
  SYR: { city: 'Syracuse', timeZone: 'America/New_York' },
  ROC: { city: 'Rochester', timeZone: 'America/New_York' },
  HPN: { city: 'White Plains', timeZone: 'America/New_York' },
  ISP: { city: 'Islip', timeZone: 'America/New_York' },
  PWM: { city: 'Portland', timeZone: 'America/New_York' },
  BTV: { city: 'Burlington', timeZone: 'America/New_York' },
  // United States: Southeast
  ATL: { city: 'Atlanta', timeZone: 'America/New_York' },
  CLT: { city: 'Charlotte', timeZone: 'America/New_York' },
  RDU: { city: 'Raleigh-Durham', timeZone: 'America/New_York' },
  MIA: { city: 'Miami', timeZone: 'America/New_York' },
  FLL: { city: 'Fort Lauderdale', timeZone: 'America/New_York' },
  MCO: { city: 'Orlando', timeZone: 'America/New_York' },
  TPA: { city: 'Tampa', timeZone: 'America/New_York' },
  PBI: { city: 'West Palm Beach', timeZone: 'America/New_York' },
  RSW: { city: 'Fort Myers', timeZone: 'America/New_York' },
  JAX: { city: 'Jacksonville', timeZone: 'America/New_York' },
  SAV: { city: 'Savannah', timeZone: 'America/New_York' },
  CHS: { city: 'Charleston', timeZone: 'America/New_York' },
  RIC: { city: 'Richmond', timeZone: 'America/New_York' },
  ORF: { city: 'Norfolk', timeZone: 'America/New_York' },
  BNA: { city: 'Nashville', timeZone: 'America/Chicago' },
  MSY: { city: 'New Orleans', timeZone: 'America/Chicago' },
  AVL: { city: 'Asheville', timeZone: 'America/New_York' },
  TYS: { city: 'Knoxville', timeZone: 'America/New_York' },
  HSV: { city: 'Huntsville', timeZone: 'America/Chicago' },
  // United States: Midwest / Central
  ORD: { city: 'Chicago', timeZone: 'America/Chicago' },
  MDW: { city: 'Chicago', timeZone: 'America/Chicago' },
  DTW: { city: 'Detroit', timeZone: 'America/Detroit' },
  MSP: { city: 'Minneapolis', timeZone: 'America/Chicago' },
  STL: { city: 'St. Louis', timeZone: 'America/Chicago' },
  MCI: { city: 'Kansas City', timeZone: 'America/Chicago' },
  MKE: { city: 'Milwaukee', timeZone: 'America/Chicago' },
  CLE: { city: 'Cleveland', timeZone: 'America/New_York' },
  CMH: { city: 'Columbus', timeZone: 'America/New_York' },
  CVG: { city: 'Cincinnati', timeZone: 'America/New_York' },
  IND: { city: 'Indianapolis', timeZone: 'America/Indiana/Indianapolis' },
  DFW: { city: 'Dallas', timeZone: 'America/Chicago' },
  DAL: { city: 'Dallas', timeZone: 'America/Chicago' },
  IAH: { city: 'Houston', timeZone: 'America/Chicago' },
  HOU: { city: 'Houston', timeZone: 'America/Chicago' },
  AUS: { city: 'Austin', timeZone: 'America/Chicago' },
  SAT: { city: 'San Antonio', timeZone: 'America/Chicago' },
  // United States: Mountain / West
  DEN: { city: 'Denver', timeZone: 'America/Denver' },
  SLC: { city: 'Salt Lake City', timeZone: 'America/Denver' },
  PHX: { city: 'Phoenix', timeZone: 'America/Phoenix' },
  ABQ: { city: 'Albuquerque', timeZone: 'America/Denver' },
  BOI: { city: 'Boise', timeZone: 'America/Boise' },
  LAS: { city: 'Las Vegas', timeZone: 'America/Los_Angeles' },
  LAX: { city: 'Los Angeles', timeZone: 'America/Los_Angeles' },
  BUR: { city: 'Burbank', timeZone: 'America/Los_Angeles' },
  LGB: { city: 'Long Beach', timeZone: 'America/Los_Angeles' },
  SNA: { city: 'Orange County', timeZone: 'America/Los_Angeles' },
  SAN: { city: 'San Diego', timeZone: 'America/Los_Angeles' },
  SFO: { city: 'San Francisco', timeZone: 'America/Los_Angeles' },
  OAK: { city: 'Oakland', timeZone: 'America/Los_Angeles' },
  SJC: { city: 'San Jose', timeZone: 'America/Los_Angeles' },
  SMF: { city: 'Sacramento', timeZone: 'America/Los_Angeles' },
  PDX: { city: 'Portland', timeZone: 'America/Los_Angeles' },
  SEA: { city: 'Seattle', timeZone: 'America/Los_Angeles' },
  ANC: { city: 'Anchorage', timeZone: 'America/Anchorage' },
  HNL: { city: 'Honolulu', timeZone: 'Pacific/Honolulu' },
  OGG: { city: 'Maui', timeZone: 'Pacific/Honolulu' },
  KOA: { city: 'Kona', timeZone: 'Pacific/Honolulu' },
  // Canada
  YYZ: { city: 'Toronto', timeZone: 'America/Toronto' },
  YUL: { city: 'Montréal', timeZone: 'America/Toronto' },
  YOW: { city: 'Ottawa', timeZone: 'America/Toronto' },
  YQB: { city: 'Québec City', timeZone: 'America/Toronto' },
  YVR: { city: 'Vancouver', timeZone: 'America/Vancouver' },
  YYC: { city: 'Calgary', timeZone: 'America/Edmonton' },
  YEG: { city: 'Edmonton', timeZone: 'America/Edmonton' },
  YHZ: { city: 'Halifax', timeZone: 'America/Halifax' },
  // Mexico, Caribbean, Central & South America
  MEX: { city: 'Mexico City', timeZone: 'America/Mexico_City' },
  CUN: { city: 'Cancún', timeZone: 'America/Cancun' },
  SJD: { city: 'Los Cabos', timeZone: 'America/Mazatlan' },
  PVR: { city: 'Puerto Vallarta', timeZone: 'America/Mexico_City' },
  SJU: { city: 'San Juan', timeZone: 'America/Puerto_Rico' },
  NAS: { city: 'Nassau', timeZone: 'America/Nassau' },
  MBJ: { city: 'Montego Bay', timeZone: 'America/Jamaica' },
  PUJ: { city: 'Punta Cana', timeZone: 'America/Santo_Domingo' },
  AUA: { city: 'Aruba', timeZone: 'America/Aruba' },
  SJO: { city: 'San José', timeZone: 'America/Costa_Rica' },
  LIR: { city: 'Liberia', timeZone: 'America/Costa_Rica' },
  PTY: { city: 'Panama City', timeZone: 'America/Panama' },
  BOG: { city: 'Bogotá', timeZone: 'America/Bogota' },
  LIM: { city: 'Lima', timeZone: 'America/Lima' },
  SCL: { city: 'Santiago', timeZone: 'America/Santiago' },
  EZE: { city: 'Buenos Aires', timeZone: 'America/Argentina/Buenos_Aires' },
  GRU: { city: 'São Paulo', timeZone: 'America/Sao_Paulo' },
  GIG: { city: 'Rio de Janeiro', timeZone: 'America/Sao_Paulo' },
  // Europe
  LHR: { city: 'London', timeZone: 'Europe/London' },
  LGW: { city: 'London', timeZone: 'Europe/London' },
  STN: { city: 'London', timeZone: 'Europe/London' },
  LCY: { city: 'London', timeZone: 'Europe/London' },
  MAN: { city: 'Manchester', timeZone: 'Europe/London' },
  EDI: { city: 'Edinburgh', timeZone: 'Europe/London' },
  DUB: { city: 'Dublin', timeZone: 'Europe/Dublin' },
  SNN: { city: 'Shannon', timeZone: 'Europe/Dublin' },
  KEF: { city: 'Reykjavík', timeZone: 'Atlantic/Reykjavik' },
  LIS: { city: 'Lisbon', timeZone: 'Europe/Lisbon' },
  OPO: { city: 'Porto', timeZone: 'Europe/Lisbon' },
  FAO: { city: 'Faro', timeZone: 'Europe/Lisbon' },
  PDL: { city: 'Ponta Delgada', timeZone: 'Atlantic/Azores' },
  MAD: { city: 'Madrid', timeZone: 'Europe/Madrid' },
  BCN: { city: 'Barcelona', timeZone: 'Europe/Madrid' },
  AGP: { city: 'Málaga', timeZone: 'Europe/Madrid' },
  SVQ: { city: 'Seville', timeZone: 'Europe/Madrid' },
  PMI: { city: 'Palma de Mallorca', timeZone: 'Europe/Madrid' },
  CDG: { city: 'Paris', timeZone: 'Europe/Paris' },
  ORY: { city: 'Paris', timeZone: 'Europe/Paris' },
  NCE: { city: 'Nice', timeZone: 'Europe/Paris' },
  LYS: { city: 'Lyon', timeZone: 'Europe/Paris' },
  MRS: { city: 'Marseille', timeZone: 'Europe/Paris' },
  AMS: { city: 'Amsterdam', timeZone: 'Europe/Amsterdam' },
  BRU: { city: 'Brussels', timeZone: 'Europe/Brussels' },
  FRA: { city: 'Frankfurt', timeZone: 'Europe/Berlin' },
  MUC: { city: 'Munich', timeZone: 'Europe/Berlin' },
  BER: { city: 'Berlin', timeZone: 'Europe/Berlin' },
  HAM: { city: 'Hamburg', timeZone: 'Europe/Berlin' },
  DUS: { city: 'Düsseldorf', timeZone: 'Europe/Berlin' },
  ZRH: { city: 'Zurich', timeZone: 'Europe/Zurich' },
  GVA: { city: 'Geneva', timeZone: 'Europe/Zurich' },
  VIE: { city: 'Vienna', timeZone: 'Europe/Vienna' },
  PRG: { city: 'Prague', timeZone: 'Europe/Prague' },
  BUD: { city: 'Budapest', timeZone: 'Europe/Budapest' },
  WAW: { city: 'Warsaw', timeZone: 'Europe/Warsaw' },
  KRK: { city: 'Kraków', timeZone: 'Europe/Warsaw' },
  CPH: { city: 'Copenhagen', timeZone: 'Europe/Copenhagen' },
  ARN: { city: 'Stockholm', timeZone: 'Europe/Stockholm' },
  OSL: { city: 'Oslo', timeZone: 'Europe/Oslo' },
  HEL: { city: 'Helsinki', timeZone: 'Europe/Helsinki' },
  FCO: { city: 'Rome', timeZone: 'Europe/Rome' },
  CIA: { city: 'Rome', timeZone: 'Europe/Rome' },
  MXP: { city: 'Milan', timeZone: 'Europe/Rome' },
  LIN: { city: 'Milan', timeZone: 'Europe/Rome' },
  VCE: { city: 'Venice', timeZone: 'Europe/Rome' },
  FLR: { city: 'Florence', timeZone: 'Europe/Rome' },
  NAP: { city: 'Naples', timeZone: 'Europe/Rome' },
  BLQ: { city: 'Bologna', timeZone: 'Europe/Rome' },
  PSA: { city: 'Pisa', timeZone: 'Europe/Rome' },
  CTA: { city: 'Catania', timeZone: 'Europe/Rome' },
  PMO: { city: 'Palermo', timeZone: 'Europe/Rome' },
  ATH: { city: 'Athens', timeZone: 'Europe/Athens' },
  JTR: { city: 'Santorini', timeZone: 'Europe/Athens' },
  JMK: { city: 'Mykonos', timeZone: 'Europe/Athens' },
  IST: { city: 'Istanbul', timeZone: 'Europe/Istanbul' },
  SAW: { city: 'Istanbul', timeZone: 'Europe/Istanbul' },
  SPU: { city: 'Split', timeZone: 'Europe/Zagreb' },
  DBV: { city: 'Dubrovnik', timeZone: 'Europe/Zagreb' },
  BSL: { city: 'Basel', timeZone: 'Europe/Paris' },
  SOF: { city: 'Sofia', timeZone: 'Europe/Sofia' },
  VLC: { city: 'Valencia', timeZone: 'Europe/Madrid' },
  // Middle East & Africa
  DXB: { city: 'Dubai', timeZone: 'Asia/Dubai' },
  AUH: { city: 'Abu Dhabi', timeZone: 'Asia/Dubai' },
  DOH: { city: 'Doha', timeZone: 'Asia/Qatar' },
  TLV: { city: 'Tel Aviv', timeZone: 'Asia/Jerusalem' },
  CAI: { city: 'Cairo', timeZone: 'Africa/Cairo' },
  RAK: { city: 'Marrakesh', timeZone: 'Africa/Casablanca' },
  CMN: { city: 'Casablanca', timeZone: 'Africa/Casablanca' },
  JNB: { city: 'Johannesburg', timeZone: 'Africa/Johannesburg' },
  CPT: { city: 'Cape Town', timeZone: 'Africa/Johannesburg' },
  NBO: { city: 'Nairobi', timeZone: 'Africa/Nairobi' },
  // Asia & Pacific
  HND: { city: 'Tokyo', timeZone: 'Asia/Tokyo' },
  NRT: { city: 'Tokyo', timeZone: 'Asia/Tokyo' },
  KIX: { city: 'Osaka', timeZone: 'Asia/Tokyo' },
  ICN: { city: 'Seoul', timeZone: 'Asia/Seoul' },
  PEK: { city: 'Beijing', timeZone: 'Asia/Shanghai' },
  PVG: { city: 'Shanghai', timeZone: 'Asia/Shanghai' },
  HKG: { city: 'Hong Kong', timeZone: 'Asia/Hong_Kong' },
  TPE: { city: 'Taipei', timeZone: 'Asia/Taipei' },
  SIN: { city: 'Singapore', timeZone: 'Asia/Singapore' },
  BKK: { city: 'Bangkok', timeZone: 'Asia/Bangkok' },
  HKT: { city: 'Phuket', timeZone: 'Asia/Bangkok' },
  KUL: { city: 'Kuala Lumpur', timeZone: 'Asia/Kuala_Lumpur' },
  DPS: { city: 'Bali', timeZone: 'Asia/Makassar' },
  MNL: { city: 'Manila', timeZone: 'Asia/Manila' },
  SGN: { city: 'Ho Chi Minh City', timeZone: 'Asia/Ho_Chi_Minh' },
  HAN: { city: 'Hanoi', timeZone: 'Asia/Ho_Chi_Minh' },
  DEL: { city: 'Delhi', timeZone: 'Asia/Kolkata' },
  BOM: { city: 'Mumbai', timeZone: 'Asia/Kolkata' },
  SYD: { city: 'Sydney', timeZone: 'Australia/Sydney' },
  MEL: { city: 'Melbourne', timeZone: 'Australia/Melbourne' },
  BNE: { city: 'Brisbane', timeZone: 'Australia/Brisbane' },
  AKL: { city: 'Auckland', timeZone: 'Pacific/Auckland' },
  NAN: { city: 'Nadi', timeZone: 'Pacific/Fiji' },
  PPT: { city: 'Papeete', timeZone: 'Pacific/Tahiti' },
  GMP: { city: 'Seoul', timeZone: 'Asia/Seoul' },
  CJU: { city: 'Jeju', timeZone: 'Asia/Seoul' },
  KIJ: { city: 'Niigata', timeZone: 'Asia/Tokyo' },
  TSA: { city: 'Taipei', timeZone: 'Asia/Taipei' },
  RMQ: { city: 'Taichung', timeZone: 'Asia/Taipei' },
  TFU: { city: 'Chengdu', timeZone: 'Asia/Shanghai' },
  DMK: { city: 'Bangkok', timeZone: 'Asia/Bangkok' },
  CNX: { city: 'Chiang Mai', timeZone: 'Asia/Bangkok' },
  KBV: { city: 'Krabi', timeZone: 'Asia/Bangkok' },
  URT: { city: 'Surat Thani', timeZone: 'Asia/Bangkok' },
};

export function airportInfo(code: string | undefined): AirportInfo | undefined {
  if (!code) return undefined;
  return AIRPORTS[code.trim().toUpperCase()];
}
